/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { inject } from 'mobx-react';
import { withTranslation } from 'react-i18next';
import withCustomComponent from 'ui/components/withCustomComponent';

@withCustomComponent('EpayPaymentButton')
@withTranslation()
@inject('appStore', 'authStore')
class EpayPaymentButton extends Component {
  render() {
    const { t, appStore, authStore, invoice, componentName } = this.props;
    const { business } = appStore;
    const { customer } = authStore;

    return (
      <a
        data-component-name={componentName}
        className="btn btn-icon btn-link text-gray-900 epay"
        data-email={customer.Email}
        data-hash={invoice.EpaySingature}
        data-description={invoice.InvoiceNumber}
        data-payurl={`${business.HomeUrl}/callbacks/paycoworkerinvoice/ok/epay/${invoice.CoworkerId}/${invoice.Id}`.toLowerCase()}
        data-amount={(invoice.TransactionTotalAmount * 100).toFixed(0)}
        data-currency={invoice.TransactionCurrency.Code}
        data-merchant-id={invoice.MerchantId}
        href="#"
      >
        <i aria-hidden="true" className="icon-credit-card"></i>
        {t('Pay by card')}
      </a>
    );
  }
}
export default EpayPaymentButton;
